import React from 'react';
// import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
// import numeral from 'numeral';
import Highcharts from 'highcharts';
import HighchartsMore from 'highcharts/highcharts-more';
import NoDataToDisplay from 'highcharts/modules/no-data-to-display';
import HighchartsReact from 'highcharts-react-official';

// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
// import { Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

// Components
// import GroupCard from '../../components/GroupCard';

// Actions
import { gameActions } from '../../actions';

import Header from '../../components/Header';
import { DebriefMenu } from './debrief_menu';
// import infoModal from '../../assets/info-modal-1.png';

// Initialize HighchartsMore
HighchartsMore(Highcharts);

NoDataToDisplay(Highcharts);

// Helper function to calculate percentiles
const calculatePercentile = (values, percentile) => {
  if (values.length === 0) return 0;
  const sorted = [...values].sort((a, b) => a - b);
  const index = (percentile / 100) * (sorted.length - 1);
  const lower = Math.floor(index);
  const upper = Math.ceil(index);
  const weight = index % 1;

  if (upper >= sorted.length) return sorted[sorted.length - 1];
  return sorted[lower] * (1 - weight) + sorted[upper] * weight;
};

// INLINE COMPONENTS
const ProcessingTimeVariationChart = ({ data }) => {
  const chartOptions = {
    chart: {
      type: 'errorbar',
      height: 500,
      backgroundColor: 'transparent',
      inverted: true, // This makes it horizontal
    },
    credits: {
      enabled: false,
    },
    title: {
      // text: 'Processing Time Variation by Group',
      text: '',
    },
    xAxis: {
      categories: data.map((group) => group.groupName),
      title: {
        text: 'Groups',
      },
    },
    yAxis: {
      min: 0,
      title: {
        text: 'Processing Time (seconds)',
      },
      gridLineWidth: 1,
    },
    legend: {
      enabled: true,
      align: 'center',
    },
    tooltip: {
      headerFormat: '<span style="font-size:12px">{point.category}</span><br/>',
      pointFormat:
        '<span style="color:{series.color}">{series.name}: </span>' +
        '<b>{point.low:.2f} - {point.high:.2f} seconds</b><br/>',
      shared: false,
    },
    plotOptions: {
      errorbar: {
        whiskerLength: 20,
        whiskerWidth: 3,
        stemWidth: 2,
        medianWidth: 2,
      },
      scatter: {
        marker: {
          symbol: 'circle',
          radius: 4,
        },
      },
      series: {
        states: {
          hover: {
            halo: null, // Disable the halo effect on hover
          },
          inactive: {
            opacity: 1,
          },
        },
      },
    },
    series: [
      {
        name: 'Min-Max Range',
        type: 'errorbar',
        data: data.map((group, index) => [index, group.minTime, group.maxTime]),
        color: '#6c757d',
        whiskerLength: 12,
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">Range: </span>' +
            '<b>{point.low:.2f} - {point.high:.2f} seconds</b><br/>',
        },
      },
      {
        name: '20th-80th Percentile',
        type: 'errorbar',
        data: data.map((group, index) => [
          index,
          group.percentile20,
          group.percentile80,
        ]),
        color: '#80bdffff',
        whiskerLength: 12,
        stemWidth: 12,
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">20th-80th Percentile: </span>' +
            '<b>{point.low:.2f} - {point.high:.2f} seconds</b><br/>',
        },
      },
      {
        name: 'Mean',
        type: 'scatter',
        data: data.map((group, index) => ({
          x: index,
          y: group.avgTime,
          groupName: group.groupName,
        })),
        color: '#434343ff',
        marker: {
          symbol: 'circle',
          radius: 6,
          fillColor: '#434343ff',
          lineColor: '#ffffff',
          lineWidth: 2,
        },
        tooltip: {
          pointFormat:
            '<span style="color:{series.color}">Mean: </span>' +
            '<b>{point.y:.2f} seconds</b><br/>',
        },
      },
    ],
    noData: {
      style: {
        fontSize: '16px',
        color: '#666',
      },
      position: {
        align: 'center',
        verticalAlign: 'middle',
      },
    },
  };

  return (
    <div className='processing-time-variation-chart'>
      <HighchartsReact
        highcharts={Highcharts}
        options={chartOptions}
        containerProps={{ style: { height: '500px', width: '100%' } }}
      />
    </div>
  );
};

class DebriefProcessingTimeVariation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      item: this.props.item || null,
    };
  }

  componentDidMount() {
    const { dispatch, match, game } = this.props;
    if (match.params.id && !game?.data?._id) {
      dispatch(gameActions.fetchGames(match.params.id));
    }
  }

  componentWillReceiveProps(newProps) {
    this.setState({
      item: newProps.item,
    });
  }

  render() {
    const { game } = this.props;
    const gameData = game.data;

    // Tasks list
    const tasksNames = [
      'front-ratio',
      'back-ratio',
      'loan-to-value',
      'risk-assessment',
      'decision',
    ];

    // Calculate processing time variation data for each group
    const processingTimeVariationData = [];

    gameData?.groups?.forEach((group, groupIndex) => {
      const groupIdentifier = group?.name || `Team ${groupIndex + 1}`;

      // Step 1: Get all decision items for this group (completed loan applications)
      const decisionItems =
        group?.items?.filter((item) => item.activity === 'decision') || [];

      // Step 2: For each completed loan, calculate total elapsed time across all tasks
      const loanProcessingTimes = [];

      decisionItems.forEach((decisionItem) => {
        const loanId = decisionItem.application;
        let totalElapsedTime = 0;
        let hasData = false;

        // Sum elapsed time across all tasks for this loan in this group
        tasksNames.forEach((taskName) => {
          const taskItems =
            group?.items?.filter(
              (item) =>
                item.activity === taskName && item.application === loanId
            ) || [];

          taskItems.forEach((item) => {
            let elapsed = 0;

            // Calculate elapsed time (elapsed_time is in milliseconds, convert to seconds)
            if (item.elapsed_time) {
              elapsed = item.elapsed_time / 1000;
              hasData = true;
            } else if (item.created_at && item.started_at) {
              elapsed =
                (new Date(item.created_at) - new Date(item.started_at)) / 1000;
              hasData = true;
            }

            totalElapsedTime += elapsed;
          });
        });

        // Only include loans that have data
        if (hasData && totalElapsedTime > 0) {
          loanProcessingTimes.push(totalElapsedTime);
        }
      });

      // Step 3: Calculate min, max, mean, and percentiles for this group
      if (loanProcessingTimes.length > 0) {
        const minTime = Math.min(...loanProcessingTimes);
        const maxTime = Math.max(...loanProcessingTimes);
        const avgTime =
          loanProcessingTimes.reduce((sum, time) => sum + time, 0) /
          loanProcessingTimes.length;
        const percentile20 = calculatePercentile(loanProcessingTimes, 20);
        const percentile80 = calculatePercentile(loanProcessingTimes, 80);

        processingTimeVariationData.push({
          groupName: groupIdentifier,
          groupId: group._id,
          minTime,
          maxTime,
          avgTime,
          percentile20,
          percentile80,
          completedLoans: loanProcessingTimes.length,
          processingTimes: loanProcessingTimes,
        });
      }
    });

    // Sort by avgTime (ascending)
    processingTimeVariationData.sort((a, b) => a.avgTime - b.avgTime);

    return (
      <div>
        <Header />

        {/* <h2 className='mt-3 sec-title fs-3'>
          Processing Time Variation{' '}
          <small className='float-end'>
            <DebriefMenu
              game_id={game.data._id}
              location={this.props.location}
            />
          </small>
        </h2> */}

        <h2 className='d-flex mt-3 sec-title fs-3'>
          <span className='d-none d-xl-inline text-nowrap'>
            Processing Time Variation
          </span>
          {/* Display sub-menu on larger viewports */}
          <DebriefMenu
            className='small d-flex justify-content-between justify-content-xl-end align-items-center ms-xl-auto w-100'
            game_id={game.data._id}
            location={this.props.location}
          />
        </h2>

        <div className='row mt-3'>
          <div className='col-12 mb-3'>
            <p className='text-center'>
              This chart shows processing time distribution of completed loan
              applications for each group sorted by the mean.
            </p>
          </div>

          {/* CHART */}
          <div className='col-12'>
            <div className='mb-5 pt-3 shadow bg-white border'>
              <ProcessingTimeVariationChart
                data={processingTimeVariationData?.slice(0, 20)}
              />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  const { player, game } = state;
  return {
    game,
    player,
  };
}

export default connect(mapStateToProps)(DebriefProcessingTimeVariation);
